export default __webpack_public_path__ + "static/media/wide_skyscraper.fca03bc1.jpg";